var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

Groupon.LS.Header.PNResponsiveMenu = (function() {
  function PNResponsiveMenu() {
    this.getVisibility = bind(this.getVisibility, this);
    this.bind = bind(this.bind, this);
    this.unbind = bind(this.unbind, this);
    this.alterDOM = bind(this.alterDOM, this);
    this.constructLanguageMenu = bind(this.constructLanguageMenu, this);
    this.constructUserMenu = bind(this.constructUserMenu, this);
    this.constructUserNavigation = bind(this.constructUserNavigation, this);
    this.initialize = bind(this.initialize, this);
    var $primaryNav, $userNav;
    this.initialize();
    this.unbind();
    this.$subnavs = this.constructSubNavFlyouts();
    $primaryNav = this.constructPrimaryNavigation(this.$subnavs);
    $userNav = this.constructUserNavigation(this.constructUserMenu(), this.constructLanguageMenu());
    this.$menu.append($primaryNav, $userNav);
    this.dedupIDs();
    this.alterDOM();
    this.bind();
  }

  PNResponsiveMenu.prototype.initialize = function() {
    this.$menu = $('#ls-resp-menu');
    this.$body = $('body');
    this.$headerRow = $('#ls-header-top-row');
    this.$overlay = $('#ls-resp-overlay');
    this.$searchBar = $('#ls-search-bar-wrapper');
    this.$userMenu = $('#ls-my-stuff');
    this.$responsiveMenuWrapper = $('#ls-resp-menu-wrapper');
    this.greenHeader = $('.ui-v3').length;
    this.popoverActiveClass = 'responsive-show-500';
    this.popoverTriggerActiveClass = 'ls-resp-active';
    this.$menuTrigger = $('#ls-resp-menu-trigger');
    this.$searchTrigger = $('#ls-resp-search-trigger');
    return this.$backButton = $('#ls-resp-back-button');
  };

  PNResponsiveMenu.prototype.constructPrimaryNavigation = function(subNavs) {
    var $primaryNav;
    $primaryNav = $('#ls-channel-nav li:not(li.p-nav-divider,li.ls-exclude-resp-nav)').clone().attr({
      role: 'menuitem',
      style: null,
      "class": 'ls-resp-menu-item'
    }).each(function() {
      var $this, i, id, len, subnav;
      id = 'subnav-' + this.id;
      for (i = 0, len = subNavs.length; i < len; i++) {
        subnav = subNavs[i];
        if (subnav.id === id && subnav.children.length) {
          subnav.id = 'ls-resp-' + this.id.replace('-tab', '-menu');
          $(subnav).attr({
            'aria-labelled': null,
            'aria-labelledby': null,
            'aria-hidden': null
          });
          $this = $(this);
          $this.children('a').attr({
            id: null,
            role: null,
            tabindex: null,
            'aria-haspopup': null,
            'aria-owns': null
          });
          $this.addClass('icon-arrow-down-large').append(subnav);
        }
      }
      return this.id = 'ls-resp-' + this.id.replace('-tab', '-trigger');
    });
    $primaryNav.find('.icon-home').removeClass();
    return $primaryNav;
  };

  PNResponsiveMenu.prototype.constructSubNavFlyouts = function() {
    var $subNavs;
    $subNavs = $('.subnav-flyout').clone().attr({
      'aria-hidden': 'true',
      role: 'menu',
      "class": 'ls-resp-submenu hide',
      style: null
    });
    $subNavs.find('.subnav-megamind').remove();
    $subNavs.find('.subnav-header').remove();
    $subNavs.find('.subnav-top-categories').remove();
    $subNavs.find('.ls-exclude-resp-sub-nav').remove();
    $subNavs.find('.subnav-link').addClass('ls-resp-submenu-item').unwrap();
    $subNavs.find('.two-column .subnav-link').unwrap().unwrap();
    return $subNavs;
  };

  PNResponsiveMenu.prototype.constructUserNavigation = function($userMenu, $langMenu) {
    var $cart, $signOut, $userName, $userNav;
    $userNav = $('.ls-user-item, .user-menu-item').clone().wrap('<li class="ls-resp-menu-item"></li>').parent();
    if ($langMenu.length) {
      $userNav = $langMenu.add($userNav);
    }
    if (($userName = $userNav.find('.user-name')).length) {
      $userName.attr({
        href: null,
        id: 'ls-resp-user-name',
        "class": 'icon-user',
        role: null,
        tabindex: null,
        'aria-haspopup': null,
        'aria-owns': null,
        'aria-describedby': null
      }).text($userName.attr('data-user-name')).parent().attr({
        id: 'subnav-usermenu-menu',
        "class": 'ls-resp-menu-item ls-resp-menu-item-user icon-arrow-down-large'
      }).append($userMenu);
      $signOut = this.$userMenu.find('#sign-out').clone().attr({
        "class": null
      }).wrap('<li class="ls-resp-menu-item"></li>').parent();
      $userNav = $userNav.add($signOut);
    }
    if (($cart = $userNav.find('.cart-widget')).length) {
      $cart = $cart.find('a');
      $userNav.find('.cart-widget').replaceWith($cart);
    }
    $userNav.find('.ls-user-item, .user-menu-item').removeClass();
    $userNav.eq(0).addClass('ls-resp-menu-divider');
    return $userNav;
  };

  PNResponsiveMenu.prototype.constructUserMenu = function() {
    var $userMenu;
    $userMenu = {};
    if (this.$userMenu.length) {
      $userMenu = this.$userMenu.clone().attr({
        "class": 'ls-resp-submenu hide',
        id: 'ls-resp-user-menu',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $userMenu.find('#sign-out').remove();
      $userMenu.find('a').addClass('ls-resp-submenu-item').each(function() {
        return this.id = 'ls-resp-' + this.id;
      });
      this.$subnavs = this.$subnavs.add($userMenu);
    }
    return $userMenu;
  };

  PNResponsiveMenu.prototype.constructLanguageMenu = function() {
    var $langMenu, $langMenuSelector;
    $langMenuSelector = {};
    if ($('.lang-menu').length) {
      $langMenuSelector = $('<span />').text($('#ls-lang-selected').text().trim()).wrap('<li></li>').parent().attr({
        id: 'ls-resp-lang-trigger',
        "class": 'ls-resp-menu-item ls-resp-lang-trigger icon-arrow-down-large'
      });
      $langMenu = $('#ls-lang-list').clone().attr({
        id: 'ls-resp-lang-menu',
        "class": 'ls-resp-submenu hide',
        role: 'menu',
        'aria-labelled': null,
        'aria-labelledby': null,
        'aria-hidden': null
      });
      $langMenu.find('a').addClass('ls-resp-submenu-item');
      $langMenuSelector.append($langMenu);
      this.$subnavs = this.$subnavs.add($langMenu);
    }
    return $langMenuSelector;
  };

  PNResponsiveMenu.prototype.dedupIDs = function() {
    return this.$responsiveMenuWrapper.find('*[id]').each(function() {
      if (!this.id.match(/ls-resp-/)) {
        return this.id = "ls-resp-" + this.id;
      }
    });
  };

  PNResponsiveMenu.prototype.alterDOM = function() {
    $('.header').prepend([this.$menuTrigger, this.$backButton, this.$searchTrigger]);
    $('.header-v2').after(this.$overlay);
    return this.$body.prepend(this.$responsiveMenuWrapper);
  };

  PNResponsiveMenu.prototype.unbind = function() {
    this.$searchTrigger.off('tap');
    this.$menuTrigger.off('tap');
    this.$overlay.off('tap');
    $('.ls-resp-submenu').parent('li').off('tap');
    $('.ls-resp-submenu a').off('tap');
    return this.$menu.empty();
  };

  PNResponsiveMenu.prototype.bind = function() {
    var $navWithMenu;
    this.$searchTrigger.on('tap', (function(_this) {
      return function(e) {
        var menuVisible;
        e.preventDefault();
        e.stopImmediatePropagation();
        menuVisible = _this.getVisibility().menuVisible;
        if (menuVisible) {
          _this.hideRespMenu();
        }
        if (!menuVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!menuVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.removeClass('noscroll');
        }
        _this.$overlay.addClass('ls-resp-overlay-search-v3');
        _this.$searchTrigger.toggleClass(_this.popoverTriggerActiveClass);
        _this.$searchBar.toggleClass(_this.popoverActiveClass);
        return $('#search').focus();
      };
    })(this));
    this.$menuTrigger.on('tap', (function(_this) {
      return function(e) {
        var searchVisible;
        e.stopImmediatePropagation();
        searchVisible = _this.getVisibility().searchVisible;
        if (searchVisible) {
          _this.hideRespSearch();
        }
        if (!searchVisible) {
          _this.toggleOverlay();
        }
        if (_this.greenHeader) {
          if (!searchVisible) {
            _this.$body.toggleClass('noscroll');
          }
        } else {
          _this.$body.toggleClass('noscroll');
        }
        _this.$body.toggleClass('show-responsive-menu');
        _this.$overlay.removeClass('ls-resp-overlay-search-v3');
        _this.$menuTrigger.toggleClass(_this.popoverTriggerActiveClass);
        return _this.toggleAriaHidden(_this.$responsiveMenuWrapper);
      };
    })(this));
    this.$overlay.on('tap', (function(_this) {
      return function(e) {
        e.preventDefault();
        _this.hideRespSearch();
        _this.hideRespMenu();
        return _this.hideOverlay();
      };
    })(this));
    $navWithMenu = $('.ls-resp-submenu').parent('li');
    $navWithMenu.on('tap', (function(_this) {
      return function(e) {
        var $flyout, $tab, $visibleSubnavs;
        $tab = $(e.currentTarget);
        $visibleSubnavs = _this.$subnavs.not('.hide').addClass('hide');
        $navWithMenu.removeClass('ls-resp-open-menu');
        $flyout = $tab.children('.ls-resp-submenu');
        if ($flyout.length && !$flyout.is($visibleSubnavs)) {
          $tab.addClass('ls-resp-open-menu');
          $flyout.removeClass('hide');
          return $flyout.find('.ls-lazy').lazyload();
        }
      };
    })(this));
    return $('.ls-resp-submenu a').on('tap', function(e) {
      return e.stopImmediatePropagation();
    });
  };

  PNResponsiveMenu.prototype.toggleAriaHidden = function($el) {
    var ariaHidden;
    ariaHidden = $el.attr('aria-hidden');
    ariaHidden = ariaHidden === 'true' ? 'false' : 'true';
    return $el.attr('aria-hidden', ariaHidden);
  };

  PNResponsiveMenu.prototype.getAttributes = function(elements, attribute) {
    var attributeArray, el, i, len;
    attributeArray = [];
    for (i = 0, len = elements.length; i < len; i++) {
      el = elements[i];
      attributeArray.push($(el).attr(attribute).parent('li').removeClass('ls-resp-open-menu'));
    }
    return attributeArray;
  };

  PNResponsiveMenu.prototype.getVisibility = function() {
    return {
      searchVisible: this.$searchBar.is(':visible'),
      menuVisible: this.$responsiveMenuWrapper.is(':visible')
    };
  };

  PNResponsiveMenu.prototype.hideRespSearch = function() {
    if (this.$searchBar.is(':visible')) {
      this.$searchTrigger.removeClass(this.popoverTriggerActiveClass);
      return this.$searchBar.removeClass(this.popoverActiveClass);
    }
  };

  PNResponsiveMenu.prototype.hideRespMenu = function() {
    this.$body.removeClass('show-responsive-menu');
    return this.$menuTrigger.removeClass(this.popoverTriggerActiveClass);
  };

  PNResponsiveMenu.prototype.hideOverlay = function() {
    this.$overlay.hide();
    return this.$body.removeClass('noscroll');
  };

  PNResponsiveMenu.prototype.toggleOverlay = function() {
    return this.$overlay.toggle();
  };

  PNResponsiveMenu.prototype.removeAria = function(menu, trigger) {
    return $(menu).attr({
      'aria-labelled': null,
      'aria-labelledby': null,
      'aria-hidden': null
    });
  };

  return PNResponsiveMenu;

})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvbW9kdWxlcy9naWdfYm9keS9oZWFkZXIvcmVzcG9uc2l2ZV9tZW51L2Zyb250ZW5kL3ZpZXcvcmVzcG9uc2l2ZV9tZW51LmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9hcmljaHRlci9yZXBvc2l0b3JpZXMvc2xzL21vZHVsZXMvZ2lnX2JvZHkvaGVhZGVyL3Jlc3BvbnNpdmVfbWVudS9mcm9udGVuZC92aWV3L3Jlc3BvbnNpdmVfbWVudS5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBTSxPQUFPLENBQUMsRUFBRSxDQUFDLE1BQU0sQ0FBQztFQUVULDBCQUFBOzs7Ozs7Ozs7QUFDWCxRQUFBO0lBQUEsSUFBQyxDQUFBLFVBQUQsQ0FBQTtJQUNBLElBQUMsQ0FBQSxNQUFELENBQUE7SUFDQSxJQUFDLENBQUEsUUFBRCxHQUFZLElBQUMsQ0FBQSxzQkFBRCxDQUFBO0lBQ1osV0FBQSxHQUFjLElBQUMsQ0FBQSwwQkFBRCxDQUE0QixJQUFDLENBQUEsUUFBN0I7SUFDZCxRQUFBLEdBQVcsSUFBQyxDQUFBLHVCQUFELENBQXlCLElBQUMsQ0FBQSxpQkFBRCxDQUFBLENBQXpCLEVBQStDLElBQUMsQ0FBQSxxQkFBRCxDQUFBLENBQS9DO0lBQ1gsSUFBQyxDQUFBLEtBQUssQ0FBQyxNQUFQLENBQWUsV0FBZixFQUE0QixRQUE1QjtJQUNBLElBQUMsQ0FBQSxRQUFELENBQUE7SUFDQSxJQUFDLENBQUEsUUFBRCxDQUFBO0lBQ0EsSUFBQyxDQUFBLElBQUQsQ0FBQTtFQVRXOzs2QkFXYixVQUFBLEdBQVksU0FBQTtJQUNWLElBQUMsQ0FBQSxLQUFELEdBQVMsQ0FBQSxDQUFFLGVBQUY7SUFDVCxJQUFDLENBQUEsS0FBRCxHQUFTLENBQUEsQ0FBRSxNQUFGO0lBQ1QsSUFBQyxDQUFBLFVBQUQsR0FBYyxDQUFBLENBQUUsb0JBQUY7SUFDZCxJQUFDLENBQUEsUUFBRCxHQUFZLENBQUEsQ0FBRSxrQkFBRjtJQUNaLElBQUMsQ0FBQSxVQUFELEdBQWMsQ0FBQSxDQUFFLHdCQUFGO0lBQ2QsSUFBQyxDQUFBLFNBQUQsR0FBYSxDQUFBLENBQUUsY0FBRjtJQUNiLElBQUMsQ0FBQSxzQkFBRCxHQUEwQixDQUFBLENBQUUsdUJBQUY7SUFDMUIsSUFBQyxDQUFBLFdBQUQsR0FBZSxDQUFBLENBQUUsUUFBRixDQUFXLENBQUM7SUFDM0IsSUFBQyxDQUFBLGtCQUFELEdBQXNCO0lBQ3RCLElBQUMsQ0FBQSx5QkFBRCxHQUE2QjtJQUU3QixJQUFDLENBQUEsWUFBRCxHQUFnQixDQUFBLENBQUUsdUJBQUY7SUFDaEIsSUFBQyxDQUFBLGNBQUQsR0FBa0IsQ0FBQSxDQUFFLHlCQUFGO1dBQ2xCLElBQUMsQ0FBQSxXQUFELEdBQWUsQ0FBQSxDQUFFLHNCQUFGO0VBZEw7OzZCQWdCWiwwQkFBQSxHQUE0QixTQUFDLE9BQUQ7QUFDMUIsUUFBQTtJQUFBLFdBQUEsR0FBYyxDQUFBLENBQUUsaUVBQUYsQ0FDZCxDQUFDLEtBRGEsQ0FBQSxDQUVkLENBQUMsSUFGYSxDQUdaO01BQUEsSUFBQSxFQUFNLFVBQU47TUFDQSxLQUFBLEVBQU8sSUFEUDtNQUVBLENBQUEsS0FBQSxDQUFBLEVBQU8sbUJBRlA7S0FIWSxDQU1iLENBQUMsSUFOWSxDQU1QLFNBQUE7QUFFTCxVQUFBO01BQUEsRUFBQSxHQUFLLFNBQUEsR0FBWSxJQUFDLENBQUE7QUFDbEIsV0FBQSx5Q0FBQTs7UUFDRSxJQUFHLE1BQU0sQ0FBQyxFQUFQLEtBQWEsRUFBYixJQUFvQixNQUFNLENBQUMsUUFBUSxDQUFDLE1BQXZDO1VBQ0UsTUFBTSxDQUFDLEVBQVAsR0FBWSxVQUFBLEdBQWEsSUFBQyxDQUFBLEVBQUUsQ0FBQyxPQUFKLENBQVksTUFBWixFQUFvQixPQUFwQjtVQUV6QixDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsSUFBVixDQUNFO1lBQUEsZUFBQSxFQUFpQixJQUFqQjtZQUNBLGlCQUFBLEVBQW1CLElBRG5CO1lBRUEsYUFBQSxFQUFlLElBRmY7V0FERjtVQUlBLEtBQUEsR0FBUSxDQUFBLENBQUUsSUFBRjtVQUlSLEtBQUssQ0FBQyxRQUFOLENBQWUsR0FBZixDQUFtQixDQUFDLElBQXBCLENBQ0U7WUFBQSxFQUFBLEVBQUksSUFBSjtZQUNBLElBQUEsRUFBTSxJQUROO1lBRUEsUUFBQSxFQUFVLElBRlY7WUFHQSxlQUFBLEVBQWlCLElBSGpCO1lBSUEsV0FBQSxFQUFhLElBSmI7V0FERjtVQU9BLEtBQUssQ0FBQyxRQUFOLENBQWUsdUJBQWYsQ0FBdUMsQ0FBQyxNQUF4QyxDQUErQyxNQUEvQyxFQWxCRjs7QUFERjthQW9CQSxJQUFDLENBQUEsRUFBRCxHQUFNLFVBQUEsR0FBYSxJQUFDLENBQUEsRUFBRSxDQUFDLE9BQUosQ0FBWSxNQUFaLEVBQW9CLFVBQXBCO0lBdkJkLENBTk87SUE4QmQsV0FBVyxDQUFDLElBQVosQ0FBaUIsWUFBakIsQ0FBOEIsQ0FBQyxXQUEvQixDQUFBO1dBRUE7RUFqQzBCOzs2QkFtQzVCLHNCQUFBLEdBQXdCLFNBQUE7QUFDdEIsUUFBQTtJQUFBLFFBQUEsR0FBVyxDQUFBLENBQUUsZ0JBQUYsQ0FBbUIsQ0FBQyxLQUFwQixDQUFBLENBQTJCLENBQUMsSUFBNUIsQ0FDVDtNQUFBLGFBQUEsRUFBZSxNQUFmO01BQ0EsSUFBQSxFQUFNLE1BRE47TUFFQSxDQUFBLEtBQUEsQ0FBQSxFQUFPLHNCQUZQO01BR0EsS0FBQSxFQUFPLElBSFA7S0FEUztJQU9YLFFBQVEsQ0FBQyxJQUFULENBQWMsa0JBQWQsQ0FBaUMsQ0FBQyxNQUFsQyxDQUFBO0lBQ0EsUUFBUSxDQUFDLElBQVQsQ0FBYyxnQkFBZCxDQUErQixDQUFDLE1BQWhDLENBQUE7SUFDQSxRQUFRLENBQUMsSUFBVCxDQUFjLHdCQUFkLENBQXVDLENBQUMsTUFBeEMsQ0FBQTtJQUNBLFFBQVEsQ0FBQyxJQUFULENBQWMsMEJBQWQsQ0FBeUMsQ0FBQyxNQUExQyxDQUFBO0lBQ0EsUUFBUSxDQUFDLElBQVQsQ0FBYyxjQUFkLENBQTZCLENBQUMsUUFBOUIsQ0FBdUMsc0JBQXZDLENBQThELENBQUMsTUFBL0QsQ0FBQTtJQUNBLFFBQVEsQ0FBQyxJQUFULENBQWMsMEJBQWQsQ0FBeUMsQ0FBQyxNQUExQyxDQUFBLENBQWtELENBQUMsTUFBbkQsQ0FBQTtXQUVBO0VBZnNCOzs2QkFpQnhCLHVCQUFBLEdBQXlCLFNBQUMsU0FBRCxFQUFZLFNBQVo7QUFDdkIsUUFBQTtJQUFBLFFBQUEsR0FBVyxDQUFBLENBQUUsZ0NBQUYsQ0FBbUMsQ0FBQyxLQUFwQyxDQUFBLENBQ1gsQ0FBQyxJQURVLENBQ0wscUNBREssQ0FDaUMsQ0FBQyxNQURsQyxDQUFBO0lBSVgsSUFBc0MsU0FBUyxDQUFDLE1BQWhEO01BQUEsUUFBQSxHQUFXLFNBQVMsQ0FBQyxHQUFWLENBQWMsUUFBZCxFQUFYOztJQUdBLElBQUcsQ0FBQyxTQUFBLEdBQVksUUFBUSxDQUFDLElBQVQsQ0FBYyxZQUFkLENBQWIsQ0FBeUMsQ0FBQyxNQUE3QztNQUNFLFNBQVMsQ0FBQyxJQUFWLENBQ0U7UUFBQSxJQUFBLEVBQU0sSUFBTjtRQUNBLEVBQUEsRUFBSSxtQkFESjtRQUVBLENBQUEsS0FBQSxDQUFBLEVBQU8sV0FGUDtRQUdBLElBQUEsRUFBTSxJQUhOO1FBSUEsUUFBQSxFQUFVLElBSlY7UUFLQSxlQUFBLEVBQWlCLElBTGpCO1FBTUEsV0FBQSxFQUFhLElBTmI7UUFPQSxrQkFBQSxFQUFvQixJQVBwQjtPQURGLENBU0MsQ0FBQyxJQVRGLENBU08sU0FBUyxDQUFDLElBQVYsQ0FBZSxnQkFBZixDQVRQLENBVUEsQ0FBQyxNQVZELENBQUEsQ0FVUyxDQUFDLElBVlYsQ0FXRTtRQUFBLEVBQUEsRUFBSSxzQkFBSjtRQUNBLENBQUEsS0FBQSxDQUFBLEVBQU8sZ0VBRFA7T0FYRixDQWFDLENBQUMsTUFiRixDQWFTLFNBYlQ7TUFjQSxRQUFBLEdBQVcsSUFBQyxDQUFBLFNBQVMsQ0FBQyxJQUFYLENBQWdCLFdBQWhCLENBQTRCLENBQUMsS0FBN0IsQ0FBQSxDQUFvQyxDQUFDLElBQXJDLENBQ1Q7UUFBQSxDQUFBLEtBQUEsQ0FBQSxFQUFPLElBQVA7T0FEUyxDQUVWLENBQUMsSUFGUyxDQUVKLHFDQUZJLENBRWtDLENBQUMsTUFGbkMsQ0FBQTtNQUdYLFFBQUEsR0FBVyxRQUFRLENBQUMsR0FBVCxDQUFhLFFBQWIsRUFsQmI7O0lBcUJBLElBQUcsQ0FBQyxLQUFBLEdBQVEsUUFBUSxDQUFDLElBQVQsQ0FBYyxjQUFkLENBQVQsQ0FBdUMsQ0FBQyxNQUEzQztNQUNFLEtBQUEsR0FBUSxLQUFLLENBQUMsSUFBTixDQUFXLEdBQVg7TUFDUixRQUFRLENBQUMsSUFBVCxDQUFjLGNBQWQsQ0FBNkIsQ0FBQyxXQUE5QixDQUEwQyxLQUExQyxFQUZGOztJQUlBLFFBQVEsQ0FBQyxJQUFULENBQWMsZ0NBQWQsQ0FBK0MsQ0FBQyxXQUFoRCxDQUFBO0lBQ0EsUUFBUSxDQUFDLEVBQVQsQ0FBWSxDQUFaLENBQWMsQ0FBQyxRQUFmLENBQXdCLHNCQUF4QjtXQUVBO0VBcEN1Qjs7NkJBc0N6QixpQkFBQSxHQUFtQixTQUFBO0FBQ2pCLFFBQUE7SUFBQSxTQUFBLEdBQVk7SUFDWixJQUFHLElBQUMsQ0FBQSxTQUFTLENBQUMsTUFBZDtNQUNFLFNBQUEsR0FBWSxJQUFDLENBQUEsU0FBUyxDQUFDLEtBQVgsQ0FBQSxDQUFrQixDQUFDLElBQW5CLENBQXdCO1FBQ2xDLENBQUEsS0FBQSxDQUFBLEVBQU8sc0JBRDJCO1FBRWxDLEVBQUEsRUFBSSxtQkFGOEI7UUFHbEMsSUFBQSxFQUFNLE1BSDRCO1FBSWxDLGVBQUEsRUFBaUIsSUFKaUI7UUFLbEMsaUJBQUEsRUFBbUIsSUFMZTtRQU1sQyxhQUFBLEVBQWUsSUFObUI7T0FBeEI7TUFTWixTQUFTLENBQUMsSUFBVixDQUFlLFdBQWYsQ0FBMkIsQ0FBQyxNQUE1QixDQUFBO01BQ0EsU0FBUyxDQUFDLElBQVYsQ0FBZSxHQUFmLENBQW1CLENBQUMsUUFBcEIsQ0FBNkIsc0JBQTdCLENBQW9ELENBQUMsSUFBckQsQ0FBMEQsU0FBQTtlQUN4RCxJQUFDLENBQUEsRUFBRCxHQUFNLFVBQUEsR0FBYSxJQUFDLENBQUE7TUFEb0MsQ0FBMUQ7TUFFQSxJQUFDLENBQUEsUUFBRCxHQUFZLElBQUMsQ0FBQSxRQUFRLENBQUMsR0FBVixDQUFjLFNBQWQsRUFiZDs7V0FjQTtFQWhCaUI7OzZCQWtCbkIscUJBQUEsR0FBdUIsU0FBQTtBQUNyQixRQUFBO0lBQUEsaUJBQUEsR0FBb0I7SUFDcEIsSUFBRyxDQUFBLENBQUUsWUFBRixDQUFlLENBQUMsTUFBbkI7TUFDRSxpQkFBQSxHQUFvQixDQUFBLENBQUUsVUFBRixDQUFhLENBQUMsSUFBZCxDQUFtQixDQUFBLENBQUUsbUJBQUYsQ0FBc0IsQ0FBQyxJQUF2QixDQUFBLENBQTZCLENBQUMsSUFBOUIsQ0FBQSxDQUFuQixDQUNwQixDQUFDLElBRG1CLENBQ2QsV0FEYyxDQUVwQixDQUFDLE1BRm1CLENBQUEsQ0FFWCxDQUFDLElBRlUsQ0FHbEI7UUFBQSxFQUFBLEVBQUksc0JBQUo7UUFDQSxDQUFBLEtBQUEsQ0FBQSxFQUFPLDhEQURQO09BSGtCO01BT3BCLFNBQUEsR0FBWSxDQUFBLENBQUUsZUFBRixDQUFrQixDQUFDLEtBQW5CLENBQUEsQ0FDWixDQUFDLElBRFcsQ0FFVjtRQUFBLEVBQUEsRUFBRyxtQkFBSDtRQUNBLENBQUEsS0FBQSxDQUFBLEVBQU8sc0JBRFA7UUFFQSxJQUFBLEVBQU0sTUFGTjtRQUdBLGVBQUEsRUFBaUIsSUFIakI7UUFJQSxpQkFBQSxFQUFtQixJQUpuQjtRQUtBLGFBQUEsRUFBZSxJQUxmO09BRlU7TUFTWixTQUFTLENBQUMsSUFBVixDQUFlLEdBQWYsQ0FBbUIsQ0FBQyxRQUFwQixDQUE2QixzQkFBN0I7TUFDQSxpQkFBaUIsQ0FBQyxNQUFsQixDQUF5QixTQUF6QjtNQUVBLElBQUMsQ0FBQSxRQUFELEdBQVksSUFBQyxDQUFBLFFBQVEsQ0FBQyxHQUFWLENBQWMsU0FBZCxFQXBCZDs7V0FzQkE7RUF4QnFCOzs2QkEyQnZCLFFBQUEsR0FBVSxTQUFBO1dBQ1IsSUFBQyxDQUFBLHNCQUFzQixDQUFDLElBQXhCLENBQTZCLE9BQTdCLENBQXFDLENBQUMsSUFBdEMsQ0FBMkMsU0FBQTtNQUN6QyxJQUFBLENBQU8sSUFBQyxDQUFBLEVBQUUsQ0FBQyxLQUFKLENBQVUsVUFBVixDQUFQO2VBQ0UsSUFBQyxDQUFBLEVBQUQsR0FBTSxVQUFBLEdBQVksSUFBQyxDQUFBLEdBRHJCOztJQUR5QyxDQUEzQztFQURROzs2QkFLVixRQUFBLEdBQVUsU0FBQTtJQUNSLENBQUEsQ0FBRSxTQUFGLENBQVksQ0FBQyxPQUFiLENBQXFCLENBQUMsSUFBQyxDQUFBLFlBQUYsRUFBZ0IsSUFBQyxDQUFBLFdBQWpCLEVBQThCLElBQUMsQ0FBQSxjQUEvQixDQUFyQjtJQUNBLENBQUEsQ0FBRSxZQUFGLENBQWUsQ0FBQyxLQUFoQixDQUFzQixJQUFDLENBQUEsUUFBdkI7V0FFQSxJQUFDLENBQUEsS0FBSyxDQUFDLE9BQVAsQ0FBZSxJQUFDLENBQUEsc0JBQWhCO0VBSlE7OzZCQU1WLE1BQUEsR0FBUSxTQUFBO0lBQ04sSUFBQyxDQUFBLGNBQWMsQ0FBQyxHQUFoQixDQUFvQixLQUFwQjtJQUNBLElBQUMsQ0FBQSxZQUFZLENBQUMsR0FBZCxDQUFrQixLQUFsQjtJQUNBLElBQUMsQ0FBQSxRQUFRLENBQUMsR0FBVixDQUFjLEtBQWQ7SUFDQSxDQUFBLENBQUUsa0JBQUYsQ0FBcUIsQ0FBQyxNQUF0QixDQUE2QixJQUE3QixDQUFrQyxDQUFDLEdBQW5DLENBQXVDLEtBQXZDO0lBQ0EsQ0FBQSxDQUFFLG9CQUFGLENBQXVCLENBQUMsR0FBeEIsQ0FBNEIsS0FBNUI7V0FDQSxJQUFDLENBQUEsS0FBSyxDQUFDLEtBQVAsQ0FBQTtFQU5NOzs2QkFRUixJQUFBLEdBQU0sU0FBQTtBQUNKLFFBQUE7SUFBQSxJQUFDLENBQUEsY0FBYyxDQUFDLEVBQWhCLENBQW1CLEtBQW5CLEVBQTBCLENBQUEsU0FBQSxLQUFBO2FBQUEsU0FBQyxDQUFEO0FBQ3hCLFlBQUE7UUFBQSxDQUFDLENBQUMsY0FBRixDQUFBO1FBQ0EsQ0FBQyxDQUFDLHdCQUFGLENBQUE7UUFDQyxjQUFlLEtBQUMsQ0FBQSxhQUFELENBQUE7UUFDaEIsSUFBbUIsV0FBbkI7VUFBQSxLQUFDLENBQUEsWUFBRCxDQUFBLEVBQUE7O1FBQ0EsSUFBQSxDQUF3QixXQUF4QjtVQUFBLEtBQUMsQ0FBQSxhQUFELENBQUEsRUFBQTs7UUFDQSxJQUFHLEtBQUMsQ0FBQSxXQUFKO1VBQ0UsSUFBQSxDQUFzQyxXQUF0QztZQUFBLEtBQUMsQ0FBQSxLQUFLLENBQUMsV0FBUCxDQUFtQixVQUFuQixFQUFBO1dBREY7U0FBQSxNQUFBO1VBR0UsS0FBQyxDQUFBLEtBQUssQ0FBQyxXQUFQLENBQW1CLFVBQW5CLEVBSEY7O1FBSUEsS0FBQyxDQUFBLFFBQVEsQ0FBQyxRQUFWLENBQW1CLDJCQUFuQjtRQUNBLEtBQUMsQ0FBQSxjQUFjLENBQUMsV0FBaEIsQ0FBNEIsS0FBQyxDQUFBLHlCQUE3QjtRQUNBLEtBQUMsQ0FBQSxVQUFVLENBQUMsV0FBWixDQUF3QixLQUFDLENBQUEsa0JBQXpCO2VBQ0EsQ0FBQSxDQUFFLFNBQUYsQ0FBWSxDQUFDLEtBQWIsQ0FBQTtNQWJ3QjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBMUI7SUFlQSxJQUFDLENBQUEsWUFBWSxDQUFDLEVBQWQsQ0FBaUIsS0FBakIsRUFBd0IsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFDLENBQUQ7QUFDdEIsWUFBQTtRQUFBLENBQUMsQ0FBQyx3QkFBRixDQUFBO1FBQ0MsZ0JBQWlCLEtBQUMsQ0FBQSxhQUFELENBQUE7UUFDbEIsSUFBcUIsYUFBckI7VUFBQSxLQUFDLENBQUEsY0FBRCxDQUFBLEVBQUE7O1FBQ0EsSUFBQSxDQUF3QixhQUF4QjtVQUFBLEtBQUMsQ0FBQSxhQUFELENBQUEsRUFBQTs7UUFDQSxJQUFHLEtBQUMsQ0FBQSxXQUFKO1VBQ0UsSUFBQSxDQUFzQyxhQUF0QztZQUFBLEtBQUMsQ0FBQSxLQUFLLENBQUMsV0FBUCxDQUFtQixVQUFuQixFQUFBO1dBREY7U0FBQSxNQUFBO1VBR0UsS0FBQyxDQUFBLEtBQUssQ0FBQyxXQUFQLENBQW1CLFVBQW5CLEVBSEY7O1FBSUEsS0FBQyxDQUFBLEtBQUssQ0FBQyxXQUFQLENBQW1CLHNCQUFuQjtRQUNBLEtBQUMsQ0FBQSxRQUFRLENBQUMsV0FBVixDQUFzQiwyQkFBdEI7UUFDQSxLQUFDLENBQUEsWUFBWSxDQUFDLFdBQWQsQ0FBMEIsS0FBQyxDQUFBLHlCQUEzQjtlQUNBLEtBQUMsQ0FBQSxnQkFBRCxDQUFrQixLQUFDLENBQUEsc0JBQW5CO01BWnNCO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUF4QjtJQWVBLElBQUMsQ0FBQSxRQUFRLENBQUMsRUFBVixDQUFhLEtBQWIsRUFBb0IsQ0FBQSxTQUFBLEtBQUE7YUFBQSxTQUFDLENBQUQ7UUFDbEIsQ0FBQyxDQUFDLGNBQUYsQ0FBQTtRQUNBLEtBQUMsQ0FBQSxjQUFELENBQUE7UUFDQSxLQUFDLENBQUEsWUFBRCxDQUFBO2VBQ0EsS0FBQyxDQUFBLFdBQUQsQ0FBQTtNQUprQjtJQUFBLENBQUEsQ0FBQSxDQUFBLElBQUEsQ0FBcEI7SUFNQSxZQUFBLEdBQWUsQ0FBQSxDQUFFLGtCQUFGLENBQXFCLENBQUMsTUFBdEIsQ0FBNkIsSUFBN0I7SUFDZixZQUFZLENBQUMsRUFBYixDQUFnQixLQUFoQixFQUF1QixDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsQ0FBRDtBQUNyQixZQUFBO1FBQUEsSUFBQSxHQUFPLENBQUEsQ0FBRSxDQUFDLENBQUMsYUFBSjtRQUVQLGVBQUEsR0FBa0IsS0FBQyxDQUFBLFFBQVEsQ0FBQyxHQUFWLENBQWMsT0FBZCxDQUFzQixDQUFDLFFBQXZCLENBQWdDLE1BQWhDO1FBQ2xCLFlBQVksQ0FBQyxXQUFiLENBQXlCLG1CQUF6QjtRQUNBLE9BQUEsR0FBVSxJQUFJLENBQUMsUUFBTCxDQUFjLGtCQUFkO1FBRVYsSUFBRyxPQUFPLENBQUMsTUFBUixJQUFtQixDQUFJLE9BQU8sQ0FBQyxFQUFSLENBQVcsZUFBWCxDQUExQjtVQUNFLElBQUksQ0FBQyxRQUFMLENBQWMsbUJBQWQ7VUFDQSxPQUFPLENBQUMsV0FBUixDQUFvQixNQUFwQjtpQkFDQSxPQUFPLENBQUMsSUFBUixDQUFhLFVBQWIsQ0FBd0IsQ0FBQyxRQUF6QixDQUFBLEVBSEY7O01BUHFCO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUF2QjtXQVlBLENBQUEsQ0FBRSxvQkFBRixDQUF1QixDQUFDLEVBQXhCLENBQTJCLEtBQTNCLEVBQWtDLFNBQUMsQ0FBRDthQUNoQyxDQUFDLENBQUMsd0JBQUYsQ0FBQTtJQURnQyxDQUFsQztFQWxESTs7NkJBcUROLGdCQUFBLEdBQWtCLFNBQUMsR0FBRDtBQUNoQixRQUFBO0lBQUEsVUFBQSxHQUFhLEdBQUcsQ0FBQyxJQUFKLENBQVMsYUFBVDtJQUNiLFVBQUEsR0FBZ0IsVUFBQSxLQUFjLE1BQWpCLEdBQTZCLE9BQTdCLEdBQTBDO1dBQ3ZELEdBQUcsQ0FBQyxJQUFKLENBQVMsYUFBVCxFQUF3QixVQUF4QjtFQUhnQjs7NkJBS2xCLGFBQUEsR0FBZSxTQUFDLFFBQUQsRUFBVyxTQUFYO0FBQ2IsUUFBQTtJQUFBLGNBQUEsR0FBaUI7QUFDakIsU0FBQSwwQ0FBQTs7TUFDRSxjQUFjLENBQUMsSUFBZixDQUFvQixDQUFBLENBQUUsRUFBRixDQUFLLENBQUMsSUFBTixDQUFXLFNBQVgsQ0FBcUIsQ0FBQyxNQUF0QixDQUE2QixJQUE3QixDQUFrQyxDQUFDLFdBQW5DLENBQStDLG1CQUEvQyxDQUFwQjtBQURGO1dBRUE7RUFKYTs7NkJBTWYsYUFBQSxHQUFlLFNBQUE7V0FDYjtNQUFBLGFBQUEsRUFBZSxJQUFDLENBQUEsVUFBVSxDQUFDLEVBQVosQ0FBZSxVQUFmLENBQWY7TUFDQSxXQUFBLEVBQWEsSUFBQyxDQUFBLHNCQUFzQixDQUFDLEVBQXhCLENBQTJCLFVBQTNCLENBRGI7O0VBRGE7OzZCQUlmLGNBQUEsR0FBZ0IsU0FBQTtJQUNkLElBQUksSUFBQyxDQUFBLFVBQVUsQ0FBQyxFQUFaLENBQWUsVUFBZixDQUFKO01BQ0UsSUFBQyxDQUFBLGNBQWMsQ0FBQyxXQUFoQixDQUE0QixJQUFDLENBQUEseUJBQTdCO2FBQ0EsSUFBQyxDQUFBLFVBQVUsQ0FBQyxXQUFaLENBQXdCLElBQUMsQ0FBQSxrQkFBekIsRUFGRjs7RUFEYzs7NkJBSWhCLFlBQUEsR0FBYyxTQUFBO0lBQ1osSUFBQyxDQUFBLEtBQUssQ0FBQyxXQUFQLENBQW1CLHNCQUFuQjtXQUNBLElBQUMsQ0FBQSxZQUFZLENBQUMsV0FBZCxDQUEwQixJQUFDLENBQUEseUJBQTNCO0VBRlk7OzZCQUdkLFdBQUEsR0FBYSxTQUFBO0lBQ1gsSUFBQyxDQUFBLFFBQVEsQ0FBQyxJQUFWLENBQUE7V0FDQSxJQUFDLENBQUEsS0FBSyxDQUFDLFdBQVAsQ0FBbUIsVUFBbkI7RUFGVzs7NkJBR2IsYUFBQSxHQUFlLFNBQUE7V0FDYixJQUFDLENBQUEsUUFBUSxDQUFDLE1BQVYsQ0FBQTtFQURhOzs2QkFJZixVQUFBLEdBQVksU0FBQyxJQUFELEVBQU8sT0FBUDtXQUNWLENBQUEsQ0FBRSxJQUFGLENBQU8sQ0FBQyxJQUFSLENBQ0U7TUFBQSxlQUFBLEVBQWlCLElBQWpCO01BQ0EsaUJBQUEsRUFBbUIsSUFEbkI7TUFFQSxhQUFBLEVBQWUsSUFGZjtLQURGO0VBRFUifQ==
